export const MAQUETTE_CLUB_ID = "7c61d7a5-7da7-409a-9bfd-18416640f640";

export function isMaquetteClub(clubId) {
  return String(clubId || "").toLowerCase() === MAQUETTE_CLUB_ID;
}

export function isLocalV2Preview() {
  return import.meta.env.DEV === true || import.meta.env.MODE === "development";
}

export function canAccessV2(clubId) {
  return isLocalV2Preview() || isMaquetteClub(clubId);
}

